module.exports = __webpack_public_path__ + "media/images/recipes/borrelballen-8811617cbdc115ab35572c36ef988281.pdf";